export interface ISlidesAnalytics {
    _id: string;
    slidesData: SlidesAnalyticsData[];
}

export interface SlidesAnalyticsData {
    slidesId: string;
    start: number;
    end: number;
}

export interface SlidesAnalyticsDTO {
    slidesId: string[];
    timeStamps: number[];
}

export interface TimeSpentOnSlideDTO {
    id: string;
    value: number;
    name?: string | number;
}

export enum SlidesAnalyticsPageSizeEnum {
    ONE = 1,
    TWO = 2,
    FIVE = 5,
}

export enum TopSlidesAnalyticsEnum {
    ALL = 0,
    FIVE = 5,
    TEN = 10,
    TWENTY = 20,
}
